export const setIsLoading = isLoading => {
  return ({
    type: "SET_IS_LOADING",
    payload: isLoading
  })
};
